module.exports = () => {
  return {
    ids: {
      label: '已选账户数',
      type: '',
      value: [],
    },
    rebate: {
      label: '返点',
      type: 'input-number',
      props: {
        min: 0,
        precision: 4,
      },
      value: 0,
    },
  };
};
